/**
 * Input — standard text input matching the Aurora chrome.
 *
 * Sized to align with Button md (h-10). Supports `invalid` state for forms.
 * Pair with the `Label` component (Radix) when used outside react-hook-form.
 */
import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  /** Render the rose error border + ring. Pair with helper text below. */
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, invalid, ...props }, ref) => (
    <input
      ref={ref}
      aria-invalid={invalid || undefined}
      className={cn(
        "h-10 w-full rounded-xl px-3.5 text-sm",
        "bg-surface text-fg placeholder:text-fg-mute",
        "border border-line",
        "transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet/50 focus-visible:border-violet/50",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        invalid && "border-rose/60 focus-visible:ring-rose/50 focus-visible:border-rose/60",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
